/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class TakeSnapshotResponse {
  /**
  * Backup job ID.
  */
  'jobId': string;
  /**
  * Snapshot ID created as part of the backup job.
  */
  'snapshotId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobId",
      "baseName": "jobId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return TakeSnapshotResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

